<template>
  <!--콘텐츠 영역-->
  <div id="sub_contents" class="sub_contents">
    <a href="#sub_contents" id="top_btn"></a>
    <div class="privacy_area">
      <div class="Title">
        <h4>개인정보 처리방침</h4>
        <p>
            송원문화재단은 개인정보보호법에 따라 이용자의 개인정보 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 하기 위하여 다음과 같은 처리방침을 두고 있습니다. 
            송원문화재단은 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.
        </p>
      </div>

      <div class="Text_area">
        <div class="Text">
          <h5>1. 개인정보 수집에 대한 동의 </h5>
          <p>
            송원문화재단은 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.<br><br>
            1. 홈페이지 일반회원 관리<br>
            - 처리목적: 국가법령 공동 활용<br>
            - 운영근거: 법제처직제 시행규칙<br><br>

            2. 심사 이후 선정 장학생 관리, 장학금 지급, 이력 관리, 사업의 지속 추진 평가 및 통계 분석 등 재단 내부 활용 목적으로 활용
          </p>
        </div>
      <div class="Text">
        <h5>2. 수집하는 개인정보 항목</h5>
        <h6>송원문화재단은 아래와 같은 개인정보를 수집하고 있습니다.</h6>
        <ul>
          <li>
            - 개인정보 수집항목 : 서비스 이용기록, 접속 IT 정보 <br>
            - 개인정보 수집방법: 홈페이지
          </li>
          <li>
            [필수적 정보]<br>
            - 개인식별정보: 성명, 생년월일 등 고유식별정보, 소속학교, 주소, 전자우편 주소, 전화번호 등 연락처<br>
            - 추천자 정보: 소속, 직위, 성명, 연락처<br>
            - 장학생 선발 및 자격유지를 위한 정보: 장학생 신청서, 가족관계증명서, 주민등록등본 등 장학생 신청 및 자격유지 심사시 제출 서류상 기재 정보 및 관리업무에 따라 발생∙생성∙수집된 개인정보<br>
            - 장학금 지원 정보 : 지급형태, 지급일시, 지급금액 및 개인별 장학금 사용내역 정보<br><br>
            [선택적 정보]<br>
            - 필수적 정보 외에 사진 등 본인이 제공한 정보<br>
            - 주거 구분, 보호자 등 가족사항, 가족 재산상황, 기존 장학금 수혜내역 등
          </li>
        </ul>
      </div>
      <div class="Text">
        <h5>3. 개인정보 보유 및 이용기간 </h5>
        <h6>
          원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. <br>
          단, 다음의 정보에 대하여 하기 사유로 명시한 기간까지 보존합니다. 
        </h6>
        <ul>
          <li>
            - 보존항목 : 서비스 이용기록, 접속 IP 정보 <br>
            - 보존근거 : 홈페이지 관리규정 <br>
            - 보존기간 : 3개월 <br><br>
            또한 장학생 탈락 시 탈락 이력 관리를 위하여 신청서는 1년, 기타 전산관리 항목은 5년동안 보관합니다.
          </li>
        </ul>
      </div>
      
      <div class="Text">
        <h5>4. 개인정보의 제3자 제공</h5>
        <ul>
          <li>
            송원문화재단은 원칙적으로 이용자의 개인정보를 제1조 (개인정보의 처리 목적)에서 명시한 범위 내에서 처리하며, 필요한 경우 아래와 같이 제3자에게 제공되고 있습니다.<br><br>

            개인정보의 제3자 제공<br>
            -초,중등교육법 제2조 및 고등교육법 제2조에 따른 학교<br>
            -지방자치단체 및 지방자치단체에서 출연한 기관<br>
            -장학사업 관련 행사개최를 지원하는 기업 등
          </li>
        </ul>
      </div>
      
      <div class="Text">
        <h5>5. 개인정보의 제공 및 취급위탁</h5>
        <p>
          송원문화재단은 개인정보의 처리업무를 위탁하는 경우 다음의 내용이 포함된 문서에 의하여 처리하고 있습니다. 
        </p>
        <ul>
          <li>
            - 수탁업체 : 동국시스템즈<br>
            - 위탁업무의 내용 : 해당 홈페이지 유지보수 수행, 응용프로그램 서비스 제공, 기술적 보호조치 등
          </li>
        </ul>
      </div> 

        <div class="Text">
          <h5>6. 개인정보에 관한 민원 서비스 </h5>
          <h6>
            회사는 귀하(사)의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련부서 및 개인정보관리책임자를 지정하고 있습니다. 
          </h6>
        <ul>
          <li>
            -개인정보 관리 책임자: 유성보 팀장<br>
            -개인정보 관리 담당자: 서은애 매니저<br>
            - 전화번호 : 051-611-5457 <br>
            - 전자메일 : we@dkfd.org
          </li>
        </ul>
        <p>
          귀하(사)께서는 송원문화재단의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보 관리책임자 혹은 담당부서로 신고하실 수 있습니다.  <br>
          송원문화재단은 귀하(사)의 신고사항에 대해 신속하고 충분한 답변을 드릴 것을 약속 드립니다. <br>
          기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다. 
        </p>
        <p>
          1. 국민권익위원회 개인정보보호위원회 (sgeum@korea.kr / 044-200-7130) <br>
          2. 정보보호 마크인증위원회 (www.eprivacy.or.kr / 02-550-9531~2) <br>
          3. 대검찰청 사이버수사과 (www.spo.go.kr / 1301) <br>
          4. 경찰청 사이버안전국 (cyberbureau.police.go.kr / 182) <br>
          5. 개인정보 분쟁조정위원회 (www.kopico.go.kr / 1833-6972) <br>
          6. 개인정보 침해신고센터 (privacy.kisa.or.kr / 118) 
        </p>
      </div>

      <div class="Text">
        <h5>7. 개인정보에 관한 민원 서비스 </h5>
        <p>
          본 개인정보 취급방침은 2023년 07월 31일에 제정되었습니다. <br>
          법령/정책 또는 보안기술의 변경에 따라 내용의 추가/삭제 및 수정이 있을 시에는 변경되는 개인정보보호정책을 시행하기 최소 10일전 홈페이지를 통해 변경사유 및 내용을 공지하도록 하겠습니다. 
        </p>
        <ul>
          <li>
            - 개인정보취급방침 버전번호 : v1 <br>
            - 개인정보취급방침 시행일자 : 2023. 07. 25
          </li>
        </ul>
      </div>
    </div>
    </div>
  </div>
</template>

<script>

export default {
  data: () => ({
    message: "PersonalPolicy.vue"
  }),
  methods: {},
  computed: {
    
    IS_MOBILE() {
      return this.$root.$data.isMobileMode;
    }
  },
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/footer/PersonalPolicy.vue